import store from '@/store';
import { IntakeAmount, IntakeResult } from '@/types';
import { Intake, ResultCategory } from '@/enums';
import { unitToIntake, unitToIntakePortion } from '@/utils';

export function getRecommendedIntake(actualIntake: IntakeAmount): IntakeAmount {
	let userAge: number = store.state.userAge || 0;

	if (userAge <= 6) {
		return {
			[Intake.FOOD]: actualIntake[Intake.DRINKS] < 250 ? 4 : 3,
			[Intake.DRINKS]: 250,
			[Intake.FOOD_PORTIONS]: 3, // This does NOT include drinks
			[Intake.DRINKS_PORTIONS]: 1
		};
	} else {
		return {
			[Intake.FOOD]: actualIntake[Intake.DRINKS] < 330 ? 5 : 3.5,
			[Intake.DRINKS]: 330,
			[Intake.FOOD_PORTIONS]: 4, // This does NOT include drinks
			[Intake.DRINKS_PORTIONS]: 1
		};
	}
}

export function getIntake(): IntakeAmount {
	const intake: IntakeAmount = {
		[Intake.FOOD]: 0,
		[Intake.DRINKS]: 0,
		[Intake.FOOD_PORTIONS]: 0,
		[Intake.DRINKS_PORTIONS]: 0
	};

	for (const input of store.state.inputs) {
		if (!input.data.includedInCalculation) {
			continue;
		}
		for (const selectedPortion of Object.values(input.selectedPortions)) {
			if (selectedPortion.index < 0) {
				continue;
			}
			const multipliedWeight: number = Math.round(input.data.portions[selectedPortion.index].weight * selectedPortion.multiplier);
			/*if (unitToIntake(input.data.unit) === Intake.FOOD && input.data.portionSize > 0) {
				const portion: number = multipliedWeight / input.data.portionSize;
				intake[unitToIntake(input.data.unit)] += portion;
			} else {
			}*/

			intake[unitToIntake(input.data.unit)] += multipliedWeight;

			if (input.data.portionSize > 0) {
				intake[unitToIntakePortion(input.data.unit)] += multipliedWeight / input.data.portionSize;
			} else if (unitToIntake(input.data.unit) === Intake.DRINKS) {
				intake[unitToIntakePortion(input.data.unit)] += multipliedWeight / 250; // 25 cl
			}
		}
	}

	//intake[Intake.FOOD] = Math.round(intake[Intake.FOOD] * 2) / 2;

	intake[Intake.FOOD_PORTIONS] = Math.round(intake[Intake.FOOD_PORTIONS] * 2) / 2;
	intake[Intake.DRINKS_PORTIONS] = Math.round(intake[Intake.DRINKS_PORTIONS] * 2) / 2;

	return intake;
}

export function getIntakeResult(): IntakeResult {
	const result: IntakeResult = {
		[Intake.FOOD]: ResultCategory.GREEN,
		[Intake.DRINKS]: ResultCategory.GREEN
	};

	const intake: IntakeAmount = getIntake();

	const recommended: IntakeAmount = getRecommendedIntake(intake);

	if (intake[Intake.FOOD] >= recommended[Intake.FOOD]) {
		result[Intake.FOOD] = ResultCategory.RED;
	} else if (intake[Intake.FOOD] >= recommended[Intake.FOOD] * 0.5) {
		result[Intake.FOOD] = ResultCategory.YELLOW;
	}

	if (intake[Intake.DRINKS] >= recommended[Intake.DRINKS]) {
		result[Intake.DRINKS] = ResultCategory.RED;
	} else if (intake[Intake.DRINKS] >= recommended[Intake.DRINKS] * 0.5) {
		result[Intake.DRINKS] = ResultCategory.YELLOW;
	}

	return result;
}

export function getIntakeFeedback(intake: Intake, amount: number): string {
	let userAge: number = store.state.userAge || 0;

	if (intake === Intake.DRINKS) {
		if (userAge <= 6) {
			return `Dit barn har drukket ${amount} ml. søde drikke i løbet af sidste uge. For et barn på 4-6 år, er der plads til ca. 250 ml. søde drikke om ugen.`;
		} else {
			return `Dit barn har drukket ${amount} ml. søde drikke i løbet af sidste uge. For et barn på 7-9 år, er der plads til ca. 330 ml. søde drikke om ugen.`;
		}
	} else {
		if (userAge <= 6) {
			return `Dit barn har spist hvad der ca. svarer til ${amount} små portioner søde sager i løbet af sidste uge. Der er plads til ca. 3 portioner søde sager for et barn i alderen 4-6 år. Hvis man ikke drikker søde drikke, er der plads til en ekstra portion søde sager.`;
		} else {
			return `Dit barn har spist hvad der ca. svarer til ${amount} små portioner søde sager i løbet af sidste uge. Der er plads til ca. 3½ portioner søde sager for et barn i alderen 7-9 år. Hvis man ikke drikker søde drikke, er der plads til 1½ ekstra portion søde sager.`;
		}
	}
}
